var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembersGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5454C8.11214 19.5454 6.26662 18.9856 4.69688 17.9367C3.12714 16.8878 1.90367 15.397 1.1812 13.6528C0.458726 11.9086 0.269694 9.98934 0.638007 8.1377C1.00632 6.28606 1.91544 4.58523 3.25039 3.25027C4.58535 1.91532 6.28619 1.0062 8.13782 0.637885C9.98946 0.269572 11.9087 0.458604 13.6529 1.18108C15.3971 1.90355 16.8879 3.12701 17.9368 4.69676C18.9857 6.2665 19.5455 8.11201 19.5455 9.99993C19.5455 12.5315 18.5398 14.9595 16.7497 16.7496C14.9596 18.5397 12.5317 19.5454 10 19.5454V19.5454Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6455 0.515383C12.0046 0.474878 12.3658 0.454543 12.7273 0.454473C15.1559 0.451829 17.4942 1.37501 19.266 3.03601C21.0379 4.697 22.1099 6.97091 22.2639 9.39466C22.4179 11.8184 21.6423 14.2097 20.0949 16.0816C18.5476 17.9535 16.3449 19.1652 13.9355 19.4699C13.1124 19.5732 12.2796 19.5704 11.4573 19.4617",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 0.515383C14.4783 0.474878 14.8394 0.454543 15.2009 0.454473C17.6295 0.451829 19.9679 1.37501 21.7397 3.03601C23.5115 4.697 24.5836 6.97091 24.7375 9.39466C24.8915 11.8184 24.1159 14.2097 22.5685 16.0816C21.0212 17.9535 18.8185 19.1652 16.4091 19.4699C15.5861 19.5732 14.7532 19.5704 13.9309 19.4617",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.091 8.73355C13.0911 9.32868 12.9147 9.91048 12.5841 10.4053C12.2534 10.9001 11.7834 11.2857 11.2335 11.5132C10.6836 11.7408 10.0785 11.8 9.49488 11.6835C8.91127 11.567 8.37535 11.2799 7.95498 10.8587C7.5346 10.4374 7.24867 9.90086 7.13338 9.31701C7.0181 8.73315 7.07864 8.12821 7.30734 7.57878C7.53604 7.02935 7.92262 6.56013 8.41814 6.23052C8.91366 5.90091 9.49583 5.72574 10.091 5.72718C10.887 5.72935 11.6498 6.04699 12.2121 6.6105C12.7745 7.17402 13.0905 7.93746 13.091 8.73355V8.73355Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 18.2845C14.0555 17.2237 13.6092 16.2182 12.8463 15.4803C12.0834 14.7425 11.0636 14.33 10.0022 14.33C8.94084 14.33 7.92102 14.7425 7.15811 15.4803C6.39521 16.2182 5.94895 17.2237 5.91357 18.2845",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersGroup);
export default __webpack_public_path__ + "static/media/membersGroup.31446da9fe0aa9d68775a37a3e09af41.svg";
export { ForwardRef as ReactComponent };